import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3D3D3D",
      "fill-rule": "evenodd",
      d: "M16.647 17.354a8.5 8.5 0 1 1 .707-.707l4 4a.5.5 0 0 1-.707.707l-4-4ZM3.5 11a7.5 7.5 0 1 1 12.87 5.235.496.496 0 0 0-.135.136A7.5 7.5 0 0 1 3.5 11Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }